export default "__VITE_ASSET__c3f4f5ef__"